import { writable } from "svelte/store";

export const EventSelected = writable({});